export default __webpack_public_path__ + "static/FbTestimonial1-21ceca92af104186f05ede5bea2101bc.jpeg";